import axios from '../../plugins/axios'

export const getStoreShopifyToken = (_, storeId) => {
  return axios.get(`/store/${storeId}/shopify-token`)
    .then(response => response)
    .catch(err => err.response)
}

export const regenerateShopifyToken = (_, storeId) => {
  return axios.post(`/store/${storeId}/shopify-token`)
    .then(response => response)
    .catch(err => err.response)
}

export const createApiKey = (_, data) => {
  return axios.post('/api-key', data)
}

export const getApiKeys = (_, { params = {} } = {}) => {
  return axios.get('/api-key', { params })
}

export const updateApiKey = (_, { id, data }) => {
  return axios.put(`/api-key/${id}`, data)
}

export const deleteApiKey = (_, id) => {
  return axios.delete(`/api-key/${id}`)
}

export const createWebhook = (_, data) => {
  return axios.post('/webhook', data)
}

export const getWebhooks = (_, { params = {} } = {}) => {
  return axios.get('/webhook', { params })
}

export const updateWebhook = (_, { id, data }) => {
  return axios.put(`/webhook/${id}`, data)
}

export const deleteWebhook = (_, id) => {
  return axios.delete(`/webhook/${id}`)
}
